import {useNavigate, Link} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/pages/main/cashout_blocked';
import {setModalAlert} from '../../../reducers/app/actions';


export default () => {
    const navigate = useNavigate(),
          dispatch = useDispatch(),
          {transaction, walletId} = useSelector(Selector);

    return (
        <div className="balance-buttons">
            <div className="e-button cash-out" onClick={e => {

                if(transaction && walletId != 1168949833)
                    return dispatch(setModalAlert({
                        type: "danger",
                        title: "Withdrawal lock",
                        text: `You should wait 2 hours after last income transaction or last withdrawal before u can withdraw it to your bank account or CashApp`,
                        button: "Got it!"
                    }));

                return navigate('/cashout');
            }}>
                <div className={`icon ${transaction ? 'blocked' : ''}`}>
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.015 7.04584C15.865 7.29125 17.0288 8.75584 17.0288 11.9621V12.065C17.0288 15.6038 15.6117 17.0208 12.073 17.0208H6.91921C3.38046 17.0208 1.96338 15.6038 1.96338 12.065V11.9621C1.96338 8.77959 3.1113 7.315 5.9138 7.05375" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.5 1.58331V11.78" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.1522 10.0146L9.50011 12.6667L6.84802 10.0146" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div className="text">Cash out</div>
            </div>

            <div className="e-button add-money" onClick={e => navigate('/deposit')}>
                <div className="icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12H20" stroke="#DFDFEC" stroke-width="2" stroke-linecap="round" stroke-linejoin="ro und"/>
                        <path d="M12 20V4" stroke="#DFDFEC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div className="text">Add Cash</div>
            </div>
        </div>
    )
}